import { render, staticRenderFns } from "./CheckoutDenied.vue?vue&type=template&id=5c809b3e&scoped=true"
import script from "./CheckoutDenied.vue?vue&type=script&lang=js"
export * from "./CheckoutDenied.vue?vue&type=script&lang=js"
import style0 from "./CheckoutDenied.vue?vue&type=style&index=0&id=5c809b3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c809b3e",
  null
  
)

export default component.exports